import { render, staticRenderFns } from "./EquipPoint.vue?vue&type=template&id=56d0978e&scoped=true"
import script from "./EquipPoint.vue?vue&type=script&lang=js"
export * from "./EquipPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0978e",
  null
  
)

export default component.exports